var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
import { Language } from '../types/Language';
export var TranslationContext = /*#__PURE__*/createContext({
  dictionaries: (_a = {}, _a[Language.ENGLISH] = {}, _a[Language.SPANISH] = {}, _a)
});
var TranslationProvider = function (props) {
  var children = props.children,
    dictionaries = props.dictionaries;
  var value = {
    dictionaries: dictionaries
  };
  return _jsx(TranslationContext.Provider, __assign({
    value: value
  }, {
    children: children
  }));
};
export default TranslationProvider;